import { createApi } from '@reduxjs/toolkit/query/react';
import { config } from 'config';
import { PRODUCT_CODE } from 'config/api.config';
import { HistoryQuestion } from 'types/refData';

import { defaultHeadersCommercialInsurance } from './defaultHeaders';
import { createCustomBaseQuery } from './utils/customBaseQuery';

export interface GetHistoryQuestionsRequest {
  effectiveDate: string;
}

export interface GetHistoryQuestionsResponse {
  total: number;
  questions: HistoryQuestion[];
}

// Use the reusable custom base query
const customBaseQuery = createCustomBaseQuery({
  baseUrl: `${config.msCommercialInsApi}/ref-data`,
  defaultHeaders: defaultHeadersCommercialInsurance,
  reducerPath: 'historyQuestionApi',
});

/* Define a service using a base URL and expected endpoints */
export const historyQuestionApi = createApi({
  reducerPath: 'historyQuestionApi',
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    getHistoryQuestions: builder.query<GetHistoryQuestionsResponse, GetHistoryQuestionsRequest>({
      query: ({ effectiveDate }) =>
        `/history-questions?productCode=${PRODUCT_CODE}&effectiveDate=${effectiveDate}`,
    }),
  }),
});

/*
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyGetHistoryQuestionsQuery } = historyQuestionApi;
